import { observer } from "mobx-react";
import React from "react";
import { GetAChannel } from "../../stores/GetAChannel";
import {
  Paper,
  Title,
  Button,
  Text,
  Center,
  AspectRatio,
  CopyButton,
  Stack,
} from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";
import { QRCodeSVG } from "qrcode.react";
import { decode } from "@gandlaf21/bolt11-decode";
import OrderStatus from "./OrderStatus";

const PayInvoice: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    const invoice = getAChannel.orderData?.data.payment.bolt11.invoice;
    const decodedInvoice = decode(invoice);
    const invoiceValue = decodedInvoice.sections[2].value / 1000;
    return (
      <Paper withBorder p="md">
        <Title order={4}>Pay Invoice To Open Channel</Title>
        {getAChannel.pollingStatus === "polling" && (
          <Stack gap="sm">
            <Text>Scan or copy the Lightning invoice below....</Text>
            <Center mt="md">
              <AspectRatio ratio={1} style={{ maxWidth: 256 }}>
                <QRCodeSVG
                  value={invoice}
                  title="Invoice QR Code"
                  size={256}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"L"}
                  marginSize={6}
                />
              </AspectRatio>
            </Center>
            <Center>
              <Text>{invoiceValue.toLocaleString()} satoshis</Text>
            </Center>
            <Center>
              <CopyButton value={invoice}>
                {({ copied, copy }) => (
                  <Button leftSection={<IconCopy />} onClick={copy} mt="md">
                    {copied ? "Copied!" : "Copy Invoice"}
                  </Button>
                )}
              </CopyButton>
            </Center>
          </Stack>
        )}
        <Center>
          <OrderStatus getAChannel={getAChannel} />
        </Center>
      </Paper>
    );
  }
);

export default PayInvoice;
